import { forwardRef } from "react";
import { cn } from "~/lib/utils";

export interface PageHeaderProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string;
  description?: string;
  icon?: React.ReactNode;
  actions?: React.ReactNode;
}

const PageHeader = forwardRef<HTMLDivElement, PageHeaderProps>(
  ({ className, title, description, icon, actions, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          "flex flex-col gap-4 sm:gap-5 border-b border-[rgba(0,0,45,0.09)] px-4 sm:px-6 lg:px-8 py-5 sm:py-6 lg:py-8",
          className
        )}
        {...props}
      >
        <div className="flex w-full flex-col sm:flex-row sm:items-start gap-3 sm:gap-4">
          <div className="flex flex-1 flex-col gap-0.5">
            <div className="flex w-full items-center gap-2">
              {icon && (
                <div className="flex h-5 w-5 sm:h-6 sm:w-6 items-center justify-center shrink-0">
                  {icon}
                </div>
              )}
              <h1 className="flex-1 text-xl sm:text-2xl font-semibold leading-tight sm:leading-[30px] tracking-[-0.1px] text-[#1c2024]">
                {title}
              </h1>
            </div>
            {description && (
              <p className="w-full text-sm sm:text-base leading-5 sm:leading-6 text-[#60646c] mt-1">
                {description}
              </p>
            )}
          </div>
          {actions && (
            <div className="flex items-center gap-2 sm:gap-3 shrink-0">
              {actions}
            </div>
          )}
        </div>
      </div>
    );
  }
);

PageHeader.displayName = "PageHeader";

export { PageHeader };
